import { FuelTypography } from '@frete.com/fuel-react';
import { FC } from 'react';

import aig from '@/assets/images/insurance/aig.webp';
import allianz from '@/assets/images/insurance/allianz.webp';
import axa from '@/assets/images/insurance/axa.webp';
import chubb from '@/assets/images/insurance/chubb.webp';
import ff from '@/assets/images/insurance/ff.webp';
import hdi from '@/assets/images/insurance/hdi.webp';
import liberty from '@/assets/images/insurance/liberty.webp';
import msig from '@/assets/images/insurance/msig.webp';
import portoSeguro from '@/assets/images/insurance/porto-seguro.webp';
import sompo from '@/assets/images/insurance/sompo.webp';
import starr from '@/assets/images/insurance/starr.webp';
import swissRe from '@/assets/images/insurance/swiss-re.webp';
import tokioMarine from '@/assets/images/insurance/tokio-marine.webp';

import { LearnMoreModalListContainer, LearnMoreModalLogoListContainer } from './styled';

type InsuranceCompaniesListProps = {
  hideLabelText?: boolean;
  customColumnNumber?: number;
};

export const InsuranceCompaniesList: FC<InsuranceCompaniesListProps> = ({
  hideLabelText = false,
  customColumnNumber,
}) => {
  const insurances = [
    { image: allianz, name: 'Allianz' },
    { image: aig, name: 'AIG' },
    { image: axa, name: 'Axa' },
    { image: tokioMarine, name: 'Tokio Marine' },
    { image: portoSeguro, name: 'Porto Seguro' },
    { image: starr, name: 'Starr' },
    { image: hdi, name: 'HDI' },
    { image: chubb, name: 'Chubb' },
    { image: ff, name: 'FF Seguros' },
    { image: liberty, name: 'Liberty' },
    { image: msig, name: 'MSIG' },
    { image: sompo, name: 'Sompo' },
    { image: swissRe, name: 'Swiss Re' },
  ];

  return (
    <LearnMoreModalListContainer>
      <LearnMoreModalLogoListContainer $customColumnNumber={customColumnNumber}>
        {insurances.map(({ image, name }) => (
          <img src={image} alt={name} key={name} />
        ))}
      </LearnMoreModalLogoListContainer>
      {!hideLabelText && (
        <FuelTypography weight="bold" size="caption" color="neutral-default">
          Estas são algumas das seguradoras aceitas.
        </FuelTypography>
      )}
    </LearnMoreModalListContainer>
  );
};
